export const insertSearch = async (className) => {
  await new Promise(r => setTimeout(r, 2));
    let navbar = document.querySelector(className);
    if(navbar.querySelector(".navbar__items")){

      let searchIcon = document.createElement("img");
      searchIcon.classList.add("navbar-search-icon");
      let searchWrap = document.querySelector(".search-wrap");
      let searchInForm = document.querySelector("#search-in-form");
      let form = document.querySelector(".search-form");

      // wyszukiwarka mobilna
      if(className.includes("mobile")){
        searchIcon.src = themeUrl+"/dist/images/glass-mobile.svg";

        let mobileForm = document.createElement("form");
        mobileForm.role="search";
        mobileForm.method="GET";
        mobileForm.action=homeUrl;
        mobileForm.classList.add("navbar__search-form");
        let inputMobile = document.createElement("input");
        inputMobile.type = "text";
        inputMobile.name="s";
        let buttonMobile = document.createElement('button');
        buttonMobile.type="submit";
        let imageMobile = document.createElement("img");
        imageMobile.src=themeUrl+"/dist/images/glass-mobile.svg";

        buttonMobile.appendChild(imageMobile)

        mobileForm.appendChild(inputMobile);
        mobileForm.appendChild(buttonMobile);
        navbar.appendChild(mobileForm);

      }
      else {
        searchIcon.src = themeUrl+"/dist/images/glass.svg";
      }
      navbar.appendChild(searchIcon);

      
      searchIcon.addEventListener("click",()=>{
        searchWrap.classList.toggle("search-wrap--hidden");
      })
  
    }
  }

  
